import { tzAxios } from 'api/axios';
import { FeaturedEventsResponse, MatchesResponse } from 'api/responseTypes';

export const getUpcomingMatches = async () =>
  (await tzAxios.get<MatchesResponse>('/ticket-zone/home?type=SPORT')).data;

export const getFeaturedEvents = async () =>
  (await tzAxios.get<FeaturedEventsResponse>('/ticket-zone/home/get-featured-events')).data;
